<template>
  <div class="container-fluid mt-2 mb-5">
    <vs-dialog not-center v-model="delSensor">
      <template #header>
        <h4 class="not-margin">Delete <b>sensor</b></h4>
      </template>
      <div class="con-content">
        <p>Are you sure you want to delete the sensor?</p>
      </div>
      <template #footer>
        <div class="container">
          <div class="row">
            <div class="col-6 d-flex align-items-center justify-content-center">
              <vs-button @click="deleteSensor()" transparent> Yes! </vs-button>
            </div>
            <div class="col-6 d-flex align-items-center justify-content-center">
              <vs-button @click="delSensor = false" danger transparent>
                Cancel
              </vs-button>
            </div>
          </div>
        </div>
      </template>
    </vs-dialog>

    <div class="row justify-content-center align-items-center">
      <div class="col-md-12 d-flex align-items-center">
        <img src="@/assets/internet.png" width="33" class="me-2" />
        <h3 class="mb-0">Internet Weather Data</h3>
      </div>
      <div class="col-md-12 mt-2 mb-5">
        <div class="row">
          <div
            class="col-md-4 mt-3"
            v-for="(item, index) in farms"
            :key="index"
          >
            <div class="card main-card h-100">
              <div class="card-body">
                <h5 class="text-main-gradient">{{ item.name }}</h5>
                <div
                  v-for="(itemStation, indexStation) in item.stations.filter(
                    (station) => station.sensor_type === 4
                  )"
                  :key="indexStation"
                >
                  <div class="row smallText">
                      <div class="col-md-12 filter-row mt-2" 
                        v-for="(item2, index2) in itemStation.sensors"
                        :key="index2"
                        v-if="parseInt(item2.sensor_type) == 4"
                      >
                      <template v-if="parseInt(item2.last_status) == 0">
                        <p class="text-main-gradient-secondary text-center">
                            <span class="d-flex align-items-center justify-content-center mb-3" style="height: 100%;">
                                <div class="circle-gray" style="width: 15px !important; height: 15px!important;"></div>
                              </span>
                            <strong>{{ item2.name }} </strong>
                          </p>                             
                          <p>
                            <strong>Id:</strong> {{ item2.id }}
                          </p>
                          <hr>

                          <p
                            class="serial-number"
                            @click="
                              turnInternet(
                                item2.id,
                                1,
                                item2.name,
                                item2.station_id,
                                itemStation.config,
                                item.storage_path,
                                item2.config
                              )
                            "
                            >⚡Turn on</p
                          >
                          <p class="serial-number" @click="last_mesure(item2)"
                            >📏Last measure</p
                          >
                          <p
                            class="serial-number"
                            @click="delete_internet(item2)"
                            >❌Delete</p
                          >
                        </template>
                        <template v-else>
                          <p class="text-main-gradient-secondary text-center">
                            <span class="d-flex align-items-center justify-content-center mb-3" style="height: 100%;">
                                <div class="circle" style="width: 15px !important; height: 15px!important;"></div>
                              </span>
                            <strong>{{ item2.name }} </strong>
                          </p>                             
                          <p>
                            <strong>Id:</strong> {{ item2.id }}
                          </p>
                          <hr>
                          <p
                            class="serial-number"
                            @click="
                              turnInternet(
                                item2.id,
                                0,
                                item2.name,
                                item2.config,
                                itemStation.config,
                                item.storage_path
                              )
                            "
                            >⚡Turn off</p
                          >
                          <p class="serial-number"  @click="last_mesure(item2)"
                            >📏Last measure</p
                          >
                          <p
                            class="serial-number"
                            @click="delete_internet(item2)"
                            >❌Delete</p
                          >
                        </template>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="col-md-8" v-if="lastMeasure && lastMeasure.length > 0">
              <h3 class="text-main-gradient-secondary">Last measure</h3>
              <p>
                <img
                  :src="lastMeasure[0].icon"
                  class="pulsating-image"
                  alt=""
                  width="33"
                />
                {{ lastMeasure[0].weatherDesc }}
                <br />
                <strong
                  >{{ selectedSensor.id }} -
                  {{ selectedSensor.name }} sensor</strong
                ><br />
                <strong>Latitude:</strong> {{ lastMeasure[0].lat }}
                <strong class="ms-3">Longitude:</strong> {{ lastMeasure[0].lon
                }}<br />
              </p>
              <div class="row">
                <div class="col-md-6">
                  <ul class="list-group smallText">
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >1.-Observation_time: </strong
                      >{{
                        moment(lastMeasure[0].observation_time)
                          .subtract(7, "days")
                          .format("MMM Do YYYY HH:m:ss")
                      }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >2.-temperature: </strong
                      >{{ lastMeasure[0].temperature }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >3.- dewPoint: </strong
                      >{{ lastMeasure[0].dewPoint }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >4.- humidity: </strong
                      >{{ lastMeasure[0].humidity }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >5.- windSpeed: </strong
                      >{{ lastMeasure[0].windSpeed }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >6.- windDirection: </strong
                      >{{ lastMeasure[0].windDirection }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul class="list-group smallText">
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >7.- pressureSurfaceLevel: </strong
                      >{{ lastMeasure[0].pressureSurfaceLevel }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >8.- cloudCover: </strong
                      >{{ lastMeasure[0].cloudCover }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >9.- uvIndex: </strong
                      >{{ lastMeasure[0].uvIndex }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >10.- precipitationIntensity: </strong
                      >{{ lastMeasure[0].precipitationIntensity }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >11.- precipitationProbability: </strong
                      >{{ lastMeasure[0].precipitationProbability }}
                    </li>
                    <li class="list-group-item">
                      <strong class="text-main-gradient-secondary"
                        >12.- precipitationType </strong
                      >{{ lastMeasure[0].precipitationType }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "axios";
import SetInterval from "set-interval";
import moment from "moment";
import wCodes from "../wCodes";

var config = require("@/config/api.json");
const API = config.api;
export default {
  name: "InternetData",
  props: {
    itemData: Object, 
    userId: {
        type: Number,
        required: true,
      },
      uid: {
        type: String,
        required: true,
      },
      userChild: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      user: null,
      farms: [],
      active: false,
      options: [],
      lastMeasure: [],
      selectedSensor: [],
      observations: [],
      delSensor: false,
      sampleTime: 1200000,
      lightning: [],
    };
  },

  async mounted() {
      await this.getFarms();
      await this.getSensors();
      console.log("sensors", this.sensors);
      // this.verifyDavis();
  },
  methods: {
    extractUrl(configJson) {
      try {
        const config = JSON.parse(configJson);
        return config.config;
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return ""; // o puedes devolver un mensaje de error si lo prefieres
      }
    },

    async getSensors() {
      await axios.get(`${API}/api-sensors`).then((response) => {
        this.sensors = response.data;
      });
    },

    storeRain(uid, stationId, rain) {
      let obj = { uid: uid, stationId: stationId, rain };
      localStorage.setItem(`r-${stationId}`, JSON.stringify(obj));
    },

    // this.getDataInternet(stationId, station_config, id, name, path, sensor_config);
    async getDataInternet(
      stationId,
      config,
      sensorId,
      name,
      path,
      sensor_config
    ) {
      var vm = this;
      console.log("Internet running.....", stationId, sensorId);
      let internetConfig = JSON.parse(config);

      let us = this.user;

      let obj = {
        stationId: stationId,
        config: config,
        sensorId: sensorId,
        name: name,
        path: path,
        sensor_config: sensor_config,
        zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      console.log("CONFIG", internetConfig);
      await axios
        .post(`${API}/getInternetData`, {
          obj,
        })
        .then((data) => {
          console.log("INTERNET DATA");
          console.log(data.data);

          let response = data.data;
          var sortedObjs = _.sortBy(response, "id");

          let obj = [];
          vm.lightning = [];
          let lightId = 0;

          sortedObjs.forEach(function (elementx, indexx) {
            vm.lightning.push({
              id: elementx.id,
              stationId: stationId,
              value: "0",
              path: path,
            });
            let interVals = elementx.intervals;
            interVals.forEach(function (element2, index2) {
              console.log("interVals");
              console.log(element2);
              let precipitationProbability =
                element2.values.precipitationProbability;
              let precipitationIntensity =
                element2.values.precipitationIntensity;
              let precipitationType = element2.values.precipitationType;
              let weatherCode = element2.values.weatherCode;
              let windSpeed = element2.values.windSpeed;

              let wCodesSearch = wCodes.weatherCodes;
              let src, weatherCodeDesc;
              wCodesSearch.find((code) => {
                if (code.id == weatherCode) {
                  src = require("@/assets/" + code.src);
                  weatherCodeDesc = code.desc;
                  vm.lightning[indexx]["icon"] = src;
                  vm.lightning[indexx]["weatherDesc"] = weatherCodeDesc;
                }
              });

              vm.lightning[indexx]["observation_time"] = element2.startTime;
              vm.lightning[indexx]["weatherValues"] = element2.values;

              //Light Rain
              if (
                parseInt(weatherCode) == 4200 &&
                parseFloat(precipitationProbability) >= 60 &&
                parseFloat(windSpeed) >= 10 &&
                parseFloat(precipitationIntensity >= 0.5)
              ) {
                vm.lightning[indexx].value = "1";
                vm.lightning[indexx]["path"] = path;
              }

              //Rain
              if (
                parseInt(weatherCode) == 4001 &&
                parseFloat(precipitationProbability) >= 50 &&
                parseFloat(windSpeed) >= 9 &&
                parseFloat(precipitationIntensity >= 0.25)
              ) {
                vm.lightning[indexx].value = "1";
                vm.lightning[indexx]["path"] = path;
              }

              //Heavy Rain
              if (
                parseInt(weatherCode) == 4201 &&
                parseFloat(precipitationProbability) >= 50
              ) {
                vm.lightning[indexx].value = "1";
                vm.lightning[indexx]["path"] = path;
              }
              //ThunderStorm
              if (parseInt(weatherCode) == 8000) {
                vm.lightning[indexx].value = "1";
                vm.lightning[indexx]["path"] = path;
              }
            });

            // Verificar si es el último elemento
            if (indexx === sortedObjs.length - 1) {
              console.log("Este es el último elemento del arreglo.");
              console.log(vm.lightning);

              // ipcRenderer.send("createInternetFile", vm.lightning);
              // Aquí puedes agregar el código que necesites ejecutar después de procesar el último elemento.
            }
          });

          // let internetData = newObj

          // ipcRenderer.send("createInternetFile", {
          //   internetData,
          //   us,
          //   path,
          //   stationId,
          //   sensorId,
          //   name,
          // });
        })
        .catch(function (error) {
          console.log("catch!!");
          console.log(error);
          // vm.displayError(`Error ${error}`);
          return;
        });
    },

    delete_internet(item) {
      this.selectedSensor = item;
      this.lastMeasure = [];
      this.delSensor = true;
    },

    deleteSensor() {
      axios
        .post(`${API}/delete-internet-sensor`, {
          sensor_id: this.selectedSensor.id,
          station_id: this.selectedSensor.station_id,
        })
        .then((response) => {
          this.notify("success", "Sensor deleted successfully");
          this.sendRealTimeMessage('refresh', 'internet', this.userChild);
        })
        .catch((error) => {
          console.error(error.response.data.error);
          this.notify("error", error.response.data.error);
        })
        .finally(() => {
          this.delSensor = false;
          this.$emit("internet-deleted", true);
        });
    },

    async last_mesure(item) {
      this.selectedSensor = item;
      this.lastMeasure = [];
      let wCodesSearch = wCodes.weatherCodes;
      let src, weatherCodeDesc;
      try {
        const response = await axios.get(
          `${API}/internet-last-measure/${this.selectedSensor.id}`
        );
        setTimeout(() => {
          this.lastMeasure = response.data;
          wCodesSearch.find((code) => {
            if (code.id == this.lastMeasure[0].weatherCode) {
              src = require("@/assets/" + code.src);
              weatherCodeDesc = code.desc;
              this.lastMeasure[0].icon = src;
              this.lastMeasure[0].weatherDesc = weatherCodeDesc;
            }
          });
        }, 333);
        console.log(response);
      } catch (error) {
        console.error("Error", error);
        this.notify("error", "Failed to fetch last measure");
      }
    },

    async turnInternet(
      id,
      value,
      name,
      stationId,
      station_config,
      path,
      sensor_config
    ) {
      try {
        const response = await axios.post(`${API}/turnInternet`, {
          id: id,
        });

        if (parseInt(value) == 0) {
          // SetInterval.clear(`internet${id}`);
          this.notify("success", `Stopped ${name}`);
          this.$emit("internet-turned", false);
          this.sendRealTimeMessage('refresh', 'internet', this.userChild);
        } else {
          SetInterval.clear(`internet${id}`);
          console.log("BEFORE:::::::::");
          console.log(id, value, name, stationId, station_config, path);
          this.getDataInternet(
            stationId,
            station_config,
            id,
            name,
            path,
            sensor_config
          );
          // SetInterval.start(
          //   () => {
          //     this.getDataInternet(
          //       stationId,
          //       station_config,
          //       id,
          //       name,
          //       path,
          //       sensor_config
          //     );
          //   },
          //   this.sampleTime,
          //   `internet${id}`
          // );
          this.notify("success", `Started ${name}`);
          this.$emit("internet-turned", true);
          this.sendRealTimeMessage('refresh', 'internet', this.userChild);
        }
        this.getFarms();
      } catch (error) {
        console.error("Error", error);
        this.notify("error", "Failed to turn on/off sensor");
      }
    },

    async getFarms() {
      this.farms = [];
      try {
        const response = await axios.get(
          `${API}/getFarmsByOwnerSingle/${this.userId}/${this.itemData.id}`
        );
        this.farms = response.data;
        this.sampleTime = parseInt(this.farms[0].sampleTime * 60000);
        console.log("GET FARS: ", this.farms, "sampletime", this.sampleTime);
      } catch (error) {
        console.error("Error", error);
        this.notify("error", "Failed to fetch farms");
      }
    },
    async verifyDavis() {
      return;
      if (this.farms && this.farms.length > 0) {
        this.farms.forEach((farm) => {
          if (farm.stations && farm.stations.length > 0) {
            const soilStations = farm.stations.filter(
              (station) => station.sensor_type === 1
            );
            if (soilStations.length > 0) {
              console.log("Stations", soilStations);
              soilStations.forEach((station) => {
                if (station.sensors && station.sensors.length > 0) {
                  const activeSensors = station.sensors.filter(
                    (sensor) => sensor.last_status === 1
                  );
                  if (activeSensors.length > 0) {
                    activeSensors.forEach((element) => {
                      console.log(element);
                      SetInterval.start(
                        () => {
                          this.getDataInternet(
                            element.config,
                            farm.storage_path,
                            element.id,
                            station.name
                          );
                        },
                        60000,
                        `soilScout${element.id}`
                      );
                      this.getDataInternet(
                        element.config,
                        farm.storage_path,
                        element.id,
                        station.name
                      );
                    });
                  }
                }
              });
            }
          }
        });
      }
    },
  },
};
</script>
